"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthController = void 0;
var neko_1 = require("../../services/neko");
var Result_1 = __importDefault(require("../../Result"));
var errors_1 = require("./errors");
/**
 * All things authentication
 */
var AuthController = /** @class */ (function () {
    function AuthController() {
    }
    AuthController.buildLoginData = function (loginData, provider) {
        var idToken = loginData.idToken, state = loginData.state, nonce = loginData.nonce, user = loginData.user;
        switch (provider) {
            case 'google':
                return { idToken: idToken };
            case 'apple':
                if (!state)
                    throw new Error(errors_1.NO_STATE);
                if (!nonce)
                    throw new Error(errors_1.NO_NONCE);
                return __assign({ idToken: idToken, state: state, nonce: nonce }, (user && { user: JSON.stringify(user) }));
            default:
                throw new Error(errors_1.NO_PROVIDER);
        }
    };
    /**
     * @deprecated
     * Authenticates the user. Sets secure cookie required to authenticate all other calls
     *
     * @param loginData - Data required to handle authentication
     * @param provider - Provider to use
     * @returns BcomToken on sucessful login
     */
    AuthController.login = function (loginData, provider) {
        return __awaiter(this, void 0, void 0, function () {
            var idToken, body, userDetails, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        idToken = loginData.idToken;
                        if (!idToken)
                            throw new Error(errors_1.NO_TOKEN);
                        body = AuthController.buildLoginData(loginData, provider);
                        return [4 /*yield*/, neko_1.neko.auth.login(provider, body)];
                    case 1:
                        userDetails = _a.sent();
                        if (!userDetails)
                            throw Error(errors_1.NOT_AUTHORIZED);
                        return [2 /*return*/, Result_1.default.ok(userDetails)];
                    case 2:
                        error_1 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(error_1.message)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @deprecated
     * Closes user session and deletes token/cookie
     *
     * @returns true if logout successfully closes session
     */
    AuthController.logout = function () {
        return __awaiter(this, void 0, void 0, function () {
            var res, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, neko_1.neko.auth.logout()];
                    case 1:
                        res = _a.sent();
                        if (!res) {
                            throw Error(errors_1.LOGOUT_ERROR);
                        }
                        return [2 /*return*/, Result_1.default.ok(true)];
                    case 2:
                        error_2 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(error_2.message)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AuthController.loginAuth = function (authDetails) {
        return __awaiter(this, void 0, void 0, function () {
            var token, authData, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        token = authDetails.token;
                        if (!token)
                            throw new Error(errors_1.NO_TOKEN);
                        return [4 /*yield*/, neko_1.neko.auth.authorize(authDetails)];
                    case 1:
                        authData = _a.sent();
                        if (!authData)
                            throw Error(errors_1.NOT_AUTHORIZED);
                        return [2 /*return*/, Result_1.default.ok(authData)];
                    case 2:
                        error_3 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(error_3.message)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AuthController.logoutAuth = function () {
        return __awaiter(this, void 0, void 0, function () {
            var res, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, neko_1.neko.auth.logoutAuth()];
                    case 1:
                        res = _a.sent();
                        if (!res) {
                            throw Error(errors_1.LOGOUT_ERROR);
                        }
                        return [2 /*return*/, Result_1.default.ok(true)];
                    case 2:
                        error_4 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(error_4.message)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return AuthController;
}());
exports.AuthController = AuthController;
